// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function BeneficialInsectsTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Beneficial Insects</p>
      <p>
        Track biocontrol releases, scout for pests, and get IPM recommendations tailored to your
        facility&apos;s predator–prey history.
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Log application — record a beneficial insect release with species, rate, and room.</li>
          <li>History — review past releases and filter by date or product.</li>
          <li>Scouting — log pest counts to inform release timing and species selection.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">Recommendations</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Use Get recommendations for suggested predators based on scouting data</li>
          <li>Pair with Applicator Log when coordinating sprays and biocontrol</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Consistent scouting and release logging helps dial in IPM before pest pressure spikes.
      </p>
    </div>
  );
}
